import { FormControl } from '@angular/forms';
import { IPersonAddress, IPersonPhone } from '@domains/person/register/data';
import { DateTime } from 'luxon';
import { IFileModel } from '@shared/filegroup/data-access';
import { TPhone, TAddress } from '@domains/person/profile/data';

export interface IGood {
  AmountUnitSale: number;
  Code: string;
  Description: string;
  Group: string;
  IsActive: boolean;
  Manufacturer: string;
  Note: string;
  RegisterDate: string;
  SupplierId: string;
  Comission?: number; //frontend only
  HasComission?: boolean; //frontend only
  HasOtherInformation?: boolean; //frontend only
  QuantityCounted?: number; //frontend only
  CommissionPercentage: number;
  CommissionAmount: number;
  BarCode: string;
  GoodId: string;
  GoodsType: string;
  QuantityStock?: number;
  Picture1?: IFileModel;
  Icon?: string;
  IsSubscriptionEnabled?: boolean;
  Picture1StorageId?: string;
}

export interface IGoodForm {
  AmountUnitSale: FormControl<number>;
  Code: FormControl<string>;
  Description: FormControl<string>;
  Group: FormControl<string>;
  IsActive: FormControl<boolean>;
  Manufacturer: FormControl<string>;
  Note: FormControl<string>;
  RegisterDate: FormControl<string>;
  SupplierId: FormControl<string>;
  CommissionPercentage: FormControl<number>;
  CommissionAmount: FormControl<number>;
  BarCode: FormControl<string>;
  GoodId: FormControl<string>;
  GoodsType: FormControl<string>;
  Icon: FormControl<string>;
  IsSubscriptionEnabled: FormControl<boolean>;
}
export interface IPurchase {
  PurchaseId?: string;
  Note: string;
  AddedBy: string;
  AddenOn: string;
  AmountFreight: number;
  AmountTotal: number;
  AmountTax: number;
  AmountTotalMerchandise: number;
  CountItems: number;
  CountTotal: number;
  Document: string;
  Goods: string;
  Items: IPurchaseItem[];
  AccountsPayable: IAccountPayable[];
  SupplierId: string;
  Situation: string;
  UpdatedBy: string;
  UpdatedOn: string;
  PlanAccountItemId: string;
}
export interface IPurchaseForm {
  PurchaseId?: FormControl<string>;
  Note: FormControl<string>;
  AddedBy: FormControl<string>;
  AddenOn: FormControl<string>;
  AmountFreight: FormControl<number>;
  AmountTotal: FormControl<number>;
  AmountTax: FormControl<number>;
  AmountTotalMerchandise: FormControl<number>;
  CountItems: FormControl<number>;
  CountTotal: FormControl<number>;
  Document: FormControl<string>;
  Goods: FormControl<string>;
  Items: FormControl<IPurchaseItem[]>;
  AccountsPayable: FormControl<IAccountPayable[]>;
  SupplierId: FormControl<string>;
  Situation: FormControl<string>;
  UpdatedBy: FormControl<string>;
  UpdatedOn: FormControl<string>;
  PlanAccountItemId: FormControl<string>;
}

export interface IAccountPayable {
  AccountsPayableId?: string;
  AmountOriginal?: number;
  Assignor?: string;
  DueOn?: string;
  IsDeleted?: boolean;
  PlanAccountItemId?: string;
}

export interface IPurchaseItem {
  AmountUnit?: number;
  DiscountAmount?: number;
  DiscountPercentage?: number;
  GoodId?: string;
  PurchaseId?: string;
  PurchaseItemId?: string;
  Quantity?: number;
  AmountTotal?: number;
}

export interface ISale {
  SaleId: string;
  SellerId: string;
  Delivery: string;
  FirstDueDate: any;
  InternalNotes: string;
  Note: string;
  AccountsReceivable: AccountsReceivable[];
  SaleConditionId?: string;
  PersonId?: string;
  AmountTotal: number;
  CountItems: number;
  DueOn: string;
  Items: {
    SaleItemId: string;
    SaleId: string;
    GoodId: string;
    Quantity: number;
    DiscountPercentage: number;
    AmountDiscount: number;
    AmountUnit: number;
    GoodDescription: string;
    QuantityStock?: number;
    AmountTotal?: number;
  }[];
  Maturities: any;
  Status: string;
  ClientName: string;
  IntervalDuration: string;
}

export interface AccountsReceivable {
  AccountsReceivableId: string;
  Amount: number;
  AmountDueCurrent: number;
  AmountTotalReceived: number;
  AmountTotalReceivedDeducted: number;
  DueOn: string;
  Index: number;
  IsPaid: boolean;
}

export interface ISaleCondition {
  SaleConditionId: string;
  AddedBy?: string;
  UpdatedBy?: string;
  AddedOn?: string;
  UpdatedOn?: string;
  Description: string;
  IntervalType: string;
  Interval: number;
  InstallmentQuantity: number;
  IsEntrance?: boolean;
  IsActive?: boolean;
  AnyValue?: boolean;
  SaleConditionDescription?: string;
}

export interface ISaleConditionForm {
  SaleConditionId?: FormControl<string>;
  AddedBy?: FormControl<string>;
  UpdatedBy?: FormControl<string>;
  AddedOn?: FormControl<string>;
  UpdatedOn?: FormControl<string>;
  Description?: FormControl<string>;
  IntervalType: FormControl<string>;
  Interval: FormControl<number>;
  InstallmentQuantity: FormControl<number>;
  IsEntrance: FormControl<boolean>;
  IsActive: FormControl<boolean>;
  AnyValue: FormControl<boolean>;
}

export interface ISaleForm {
  SellerId: FormControl<string>;
  Delivery: FormControl<string>;
  InternalNotes: FormControl<string>;
  Note: FormControl<string>;
  SaleConditionId: FormControl<string>;
  SaleConditionDescription: FormControl<string>;
  PersonId: FormControl<string>;
  AmountTotal: FormControl<number>;
  CountItems: FormControl<number>;
  DueOn: FormControl<any>;
  Items: FormControl<any[]>;
  Maturities: FormControl<any[]>;
  Status: FormControl<string>;
  SaleId: FormControl<string>;
  ClientName: FormControl<string>;
  IntervalDuration: FormControl<string>;
}

export interface ISupplier {
  Addresses: TAddress[];
  Email?: string;
  FirstName?: string;
  FiscalIdentity?: string;
  GenderType: number;
  IsActive?: boolean;
  LastName?: string;
  LegalBusinessName: string;
  PersonId?: string;
  PersonType?: number;
  Phones?: TPhone[];
  RegistrationType?: number;
  TradeName: string;
  BusinessPhone: string;
}

export interface ISupplierForm {
  Addresses: FormControl<IPersonAddress[]>;
  Email?: FormControl<string>;
  FirstName?: FormControl<string>;
  FiscalIdentity?: FormControl<string>;
  GenderType?: FormControl<number>;
  IsActive?: FormControl<boolean>;
  LastName?: FormControl<string>;
  LegalBusinessName: FormControl<string>;
  PersonId?: FormControl<string>;
  PersonType?: FormControl<number>;
  Phones?: FormControl<IPersonPhone[]>;
  RegistrationType?: FormControl<number>;
  TradeName: FormControl<string>;
  BusinessPhone: FormControl<string>;
  Phone: FormControl<string>;
}

export enum EStockAdjustmentMode {
  SetAbsolute = 1,
  Increase = 2,
  Decrease = 3,
}

export interface IManualAdjust {
  StockAdjustmentId?: string;
  GoodId: string;
  Quantity: number;
  AdjustmentOn: string;
  Reason: string;
  Note: string;
  Mode?: EStockAdjustmentMode;
  QuantityAfter?: number;
  QuantityBefore?: number;
}

export interface IInventoryBalance {
  GoodId?: string;
  Quantity?: number;
  StockAdjustmentId?: string;
}

export type TSaleSettings = {
  DailyInterestRate: number;
  GracePeriod: number;
  IsAllowWithNoStock: boolean;
  LateFeeAmount: number;
  LateFeePercentage: number;
  TenantId: string;
};

export enum ECommisionType {
  PERCENT = 'P',
  VALUE = 'V',
}

export enum EIntervalType {
  MONTH = 'M',
  DAY = 'D',
}

export interface IStockOnDate {
  GoodId?: string;
  Quantity?: number;
  Date?: string;
  [key: string]: unknown;
}
